import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f9d175d8")

_pushScopeId("data-v-f9d175d8")
const _hoisted_1 = { class: "search-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("検索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Excel出力")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("クリア")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_cus_input = _resolveComponent("cus-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_cus_table = _resolveComponent("cus-table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_cus_select, {
          modelValue: _ctx.table.queryForm.toiawaseJokyoCd,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.table.queryForm.toiawaseJokyoCd = $event)),
          size: "small",
          clearable: "",
          inputId: "searchToiawaseJokyoCd",
          labelName: "対応状況"
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.toiawaseJokyoOptions, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.toiawase_jokyo,
                value: item.toiawase_jokyo_cd
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_cus_input, {
          inputId: "searchKjnNm",
          labelName: "氏名",
          modelValue: _ctx.table.queryForm.kjnNm,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.table.queryForm.kjnNm = $event)),
          onEnterKeyUp: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_cus_input, {
          inputId: "searchKaishaNm",
          labelName: "会社名",
          modelValue: _ctx.table.queryForm.kaishaNm,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.table.queryForm.kaishaNm = $event)),
          onEnterKeyUp: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSearch(1)))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "search-button",
          type: "primary",
          icon: "el-icon-search",
          size: "mini",
          plain: "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleSearch(1)))
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          class: "excel-button",
          type: "primary",
          icon: "el-icon-download",
          size: "mini",
          plain: "",
          loading: _ctx.exportLoading,
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleExport2excel()))
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          class: "clear-button",
          icon: "el-icon-close",
          size: "mini",
          plain: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleClear()))
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_cus_table, {
      table: _ctx.table,
      tableConfig: _ctx.tableHeader,
      currentPage: _ctx.table.queryForm.page,
      "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => (_ctx.table.queryForm.page = $event)),
      "page-size": _ctx.table.queryForm.limit,
      "page-sizes": [20, 50, 80, 100],
      onCurrentChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.getList())),
      onSizeChange: _ctx.handleSizeChange,
      ref: "tableRef"
    }, {
      append: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", null, [
              _createVNode(_component_el_tooltip, {
                content: "詳細",
                placement: "left",
                effect: "light"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_button, {
                    class: "edit-btn",
                    circle: "",
                    size: "mini",
                    onClick: ($event: any) => (_ctx.goToDetail(scope.row.id)),
                    icon: "el-icon-edit",
                    plain: ""
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["table", "tableConfig", "currentPage", "page-size", "onSizeChange"])
  ], 64))
})